import { type SubmitHandler, useForm } from 'react-hook-form';

import { FormErrorMessage } from '@/components/FormErrorMessage';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { useCourseLessonsStore } from '@/stores/lessonStore';

import LessonPlanGroup from './LessonPlanGroup';

interface FormValues {
	groupTitle: string;
}

const LessonPlans = () => {
	const { lessons, addLessonSection } = useCourseLessonsStore();
	const {
		register,
		handleSubmit,
		reset,
		formState: { errors },
	} = useForm<FormValues>();

	const onSubmit: SubmitHandler<FormValues> = ({ groupTitle }) => {
		addLessonSection(groupTitle.trim());
		reset();
	};

	return (
		<div className="flex flex-col h-full overflow-hidden">
			{/* Add group form */}
			<div className="px-3 pt-4 pb-3 border-b border-border shrink-0">
				<p className="text-xxs font-semibold text-muted-foreground uppercase tracking-widest pb-2">
					New Group
				</p>
				<form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-2">
					<Input
						type="text"
						placeholder="Group title…"
						className="h-8 text-sm"
						{...register('groupTitle', {
							required: 'Title is required',
							validate: (v) => v.trim() !== '' || 'Title is required',
						})}
					/>
					<FormErrorMessage
						className="text-[11px] -mt-1"
						isShowing={!!errors?.groupTitle}
						message={errors.groupTitle?.message}
					/>
					<Button variant="secondary" size="small" type="submit" className="w-full gap-1.5">
						Add Group
					</Button>
				</form>
			</div>

			{/* Groups list */}
			<div className="flex-1 overflow-y-auto py-2 px-2">
				{lessons.length === 0 && (
					<p className="text-xs text-muted-foreground text-center py-6 px-3">
						No groups yet. Create one above to get started.
					</p>
				)}
				{lessons.map((lesson) => (
					<LessonPlanGroup key={lesson.id} group={lesson} />
				))}
			</div>
		</div>
	);
};

export default LessonPlans;
